









import {Component, Emit, Prop, Vue} from "vue-property-decorator";

@Component
export default class Search extends Vue {
}
